import { Localization } from './localization.enum';
import { Role } from './opportunities';
import { Permission } from './permissions.enum';

export interface GeekItem {
  id: string;
  firstName: string;
  lastName: string;
  nick?: string;
  avatarUrl?: string;
  isActive: boolean;
}

export interface GeekItemWithJobTitle extends GeekItem {
  jobTitle: string;
}

export interface GeekWithStatus extends GeekItem {
  status: GeekStatus;
}

export interface GeekItemWithRole {
  geek: GeekItem;
  role: Role;
}

export interface GeekItemWithActivityQuantity extends GeekItem {
  activityQuantity: number;
}

export interface GeekItemForLeaderboard extends GeekItem {
  isClassified: boolean;
  isActive: boolean;
  leaderboardPosition?: number;
  level: number;
}

export interface Geek extends GeekItem {
  gCoins: number;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  isGCoinsManager: boolean;
  localization: Localization;
  permissions: Permission[];
}

export interface AdminGroup {
  jobTitle: string;
  admins: GeekItemWithJobTitle[];
}

export enum GeekStatus {
  Inactive = 'inactive',
  Active = 'active',
}

export interface GeekJobInfo {
  department: string;
  location: string;
  designation: string;
  practice: string;
  additionalInfo?: string;
}

export interface GeekNames {
  firstName: string;
  lastName: string;
}
